<template>
  <div class="col-sm-12 mt-sm-0">
    <div class="card cardimage">
      <div class="card-body">
        <div class="row">         
          <form ref="newVariantForm" class="needs-validation" novalidate>
            <div class="row align-bottom">
              <div class="col-12 col-sm-2 mt-sm-0">
                <label class="text-primary">{{ $t('key_title_ean') }} <span style="color:red">*</span> </label>
                <input v-model="newVariant.ean" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_ean')" required />
              </div>
              <div class="col-12 col-sm-2 mt-sm-0">
                <label class="text-primary">{{ $t('key_title_property1') }}
                  <span style="color:red">*</span>
                  <span class="mx-3 " style="cursor:pointer"
                    :title="$t('key_description_property1')">
                    <i class="fas fa-question-circle text-secondary"></i>
                  </span>
                </label>
                <input v-model="newVariant.property1" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_property1')" required />
              </div>
              <div class="col-12 col-sm-2 mt-sm-0">
                <label class="text-primary">{{ $t('key_title_property2') }}
                  <span style="color:red">*</span>
                  <span class="mx-3 " style="cursor:pointer"
                    :title="$t('key_description_property2')">
                    <i class="fas fa-question-circle text-secondary"></i>
                  </span>
                </label>
                <input v-model="newVariant.property2" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_property2')" required />
              </div>
              <div class="col-12 col-sm-2 mt-sm-0">
                <label class="text-primary">{{ $t('key_title_sku') }}</label>
                <input v-model="newVariant.sku" class="form-control" type="text" maxLength="50" :placeholder="$t('key_placeholder_sku')" />
              </div>
              <div class="col-12 col-sm-1 mt-sm-0">
                <label class="text-primary">{{ $t('key_title_weight') }}  <span style="color:red">*</span> </label>
                <input v-model="newVariant.weight" class="form-control" type="number" step="0.01" placeholder="0" required/>
              </div>
              <div class="col-12 col-sm-1 mt-sm-0 py-2">
                <button class="mt-4 p-2 btn-mas" type="button" :title="$t('key_button_add')" @click="saveVariant()">
                  <i class="fa fa-plus text-secondary" aria-hidden="true">
                  </i>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 mt-sm-0 scrollable">
            <form ref="editVariantForm" class="needs-validation" novalidate>
            <table id="datatable-basic" class="table table-flush">
              <thead class="thead-light ">
                <tr class="row">
                  <th style="width: 25rem" class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_ean') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_property1') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_property2') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_sku') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_weight') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_status') }}</span>
                  </th>
                  <th class=" col text-uppercase text-secondary text-xxs font-weight-bold opacity-7 p-2">
                    <span class="my-2 text-xs columns">{{ $t('key_theader_actions') }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) of localValue" :key="index" class="row">
                  <td style="width: 15rem" class="col text-sm">
                    <p class="text-xs font-weight-bold">{{item.ean}}</p>
                  </td>
                  <td style="width: 15rem" class="col text-sm">
                    <input v-model="item.property1" :disabled="!indexHabilitados.includes(index)" class="form-control text-xs font-weight-bold"
                      type="text" maxLength="50" required/>
                  </td>
                  <td style="width: 15rem" class="col text-sm  ">
                    <input v-model="item.property2" :disabled="!indexHabilitados.includes(index)" class="form-control text-xs font-weight-bold"
                      type="text" maxLength="50" required/>
                  </td>
                  <td style="width: 15rem" class="col">
                    <input v-model="item.sku" :disabled="!indexHabilitados.includes(index)" class="form-control text-xs font-weight-bold"
                      type="text" maxLength="50" />
                  </td>
                  <td style="width: 15rem" class="col text-xs font-weight-bold">
                    <input v-model="item.weight" :disabled="!indexHabilitados.includes(index)" class="form-control text-xs font-weight-bold"
                      type="number" step="0.01" required/>
                  </td>
                  <td style="width: 10%; text-align: center;" class="col font-weight-bold">
                    <span v-if="item.status == 'REGISTRADO'" class="badge badge-saved badge-sm">{{ $t('key_status_registered') }}</span>
                    <span v-else class="badge badge-error badge-sm" :title="item.errors">{{ $t('key_status_not_registered') }}</span>
                  </td>
                  <td style="width: 10rem" class="col text-sm">
                    <a class="mx-3" style="cursor:pointer" :title="[indexHabilitados.includes(index)?$t('key_description_save_variant'):$t('key_description_edit_variant')]"
                      @click="changeVariant(index)">
                      <i class="fas text-secondary" :class="[indexHabilitados.includes(index)?'fa-check':'fa-user-edit']"></i>
                    </a>
                    <span class="d-inline-block"  :title="$t('key_title_aux')">
                    <a class="mx-3"  style="cursor:pointer" data-bs-toggle="modal" data-bs-target="#auxModal" @click="auxModal(item)">
                      <i class="fas fa-plus text-secondary"></i>
                    </a>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          </div>
        </div>
      </div>
    </div>
  </div>
    <new-aux  ref="thisModal" :variant="selectedVariant" @aux-changed="onAuxChange"></new-aux>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import NewAux from './NewAux.vue';
export default {

  name: "Variants",
  components: {
    NewAux
  },
  props: {
    variants: {
      type: Array,
      default:()=>{
        return [];
      }
    },
  },
emits: ['variant-added', 'variant-updated'],
  data() {
    return {
      indexHabilitados:[],
      newVariant:{
        property1:'',
        property2:'',
        ean:'',
        sku:'',
        weight:0,
        status: '-'
      },
      selectedVariant: {},
      localValue: this.variants
    }
  },
  watch: {
    variants(newValue) {
      this.localValue=newValue;
    }
  },
  mounted () {
    this.localValue= this.variants;
    setTooltip(this.$store.state.bootstrap);
    },
  methods: {
    changeVariant(index) {
      if (this.indexHabilitados.includes(index)) {
      let form = this.$refs.editVariantForm;
      form.classList.add('was-validated');
      if (form.checkValidity()) {
        this.$emit('variant-updated', this.localValue[index]);
        this.indexHabilitados = this.indexHabilitados.filter(function (e) {
          return e !== index
        })
      }
      } else {
        // this.indexHabilitados.pop();
        this.indexHabilitados.push(index);
      }
    },
    saveVariant() {
      let form = this.$refs.newVariantForm;
      form.classList.add('was-validated');
      if (form.checkValidity()) {
        this.$emit('variant-added', this.newVariant);
        this.newVariant = {
          property1: '',
          property2: '',
          ean: '',
          sku: '',
          weight: 0,
          status: '-'
        }
        form.classList.remove('was-validated');
      }
    },
    onAuxChange(value){
      for (let i=0; i<this.localValue.length; i++){
        if (this.localValue[i].ean== value.ean){
          this.localValue[i].aux1=value.aux1;
          this.localValue[i].aux2=value.aux2;
          this.localValue[i].aux3=value.aux3;
          this.localValue[i].aux4=value.aux4;
          this.localValue[i].aux5=value.aux5;
        }
      }
      this.$emit('variant-updated', this.localValue);
    },
    auxModal(item){
      this.selectedVariant= { ...item};
    }
  },
};
</script>

<style scoped>

.form-control:disabled {
  background-color: white;
  border: 1px solid transparent;
}
.btn-mas {
  background-color: white !important;
  border: none;
}
 
.scrollable {
  height: 35rem !important;
  overflow: auto;
}

.cardimage {
  position: inherit !important;
}

.columns {
  max-width: 150px;
}

</style>
